<template>
<div>
  <v-data-table
    :headers="headers"
    :items="getAbonos"
    :items-per-page="5"
    class="elevation-1"
  >
    <template v-slot:[`item.fecha`]="{ item }">
          {{ item.fecha | formatdate}}
     </template>

     <template v-slot:[`item.opciones`]="{ item }">
          <v-icon small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
     </template>
    <template v-slot:no-data>
    <h3>No se han recibido pagos</h3>     
    </template>
  </v-data-table>
  </div>
</template>
<script>
import axios from "axios";
import Swal from 'sweetalert2'
import {mapGetters} from 'vuex'

export default {
    name:"ListarAbonos",
    data() {
        return {
            headers: [
                { text: 'Descripcion', value: 'descripcion' },
                { text: 'Fecha', value: 'fecha' },
                { text: 'Monto', value: 'monto' },
                { text: 'Saldo', value: 'saldo' },
                { text: '', value: 'opciones' },
            ],
        };
    },
    computed:{
        ...mapGetters(['getAbonos','getInfoCredito','getTokenUser','getUrlApi'])
    },
    methods: {
      async deleteItem(item){
        console.log(item)
        try {
          await axios.delete(`${this.getUrlApi}/abonos/`+item.idabono,this.getTokenUser)
          //await  this.$store.dispatch('setAbonos',this.getIdCredito)
          await  this.$store.dispatch('setAbonos',this.getInfoCredito.idcredito)

          Swal.fire({
            icon: 'success',
            title: 'El abono fue Eliminado',
            showConfirmButton: false,
            timer: 1500
          })
        } catch (error) {
          console.log(error)
           Swal.fire('Error al eliminar el Abono','Ocurrio un error al intentar eliminar el abono','error')
        }
      }
    },
}
</script>